import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiUrlUtil } from 'src/app/util/api-url-util';

const CONTROLLERTENANT = 'tenantManagement';
const CONTROLLER = 'Dashboard';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private _expiration = 0;

  constructor(private http: HttpClient) {}

  get expiration(): number {
    return this._expiration;
  }

  set expiration(value: number) {
    this._expiration = value;
  }

  public getExpiration(): Observable<number> {
    return this.http.get<number>(`${CONTROLLER}/getExpiration`).pipe(
      map((response: any) => response),
      catchError(this.handleError)
    );
  }

  public addWhatsappCick(): Promise<any> {
    return this.http.post(`${CONTROLLER}/whatsapp`, {}).toPromise();
  }

  public getTenantManagement(
    subDomain: string,
    tenantId: string
  ): Observable<any> {
    const body = {
      tenantId,
      subDomain,
    };

    return this.http
      .post(
        `${ApiUrlUtil.getFormattedUrl()}/${CONTROLLERTENANT}/tenantManagement`,
        body
      )
      .pipe(catchError(this.handleError));
  }
  private handleError(errorResponse: Response) {
    return throwError(errorResponse || 'Server error');
  }
}
